import { css } from 'styled-components';

export default {
  container: css`
    display: flex;
    justify-content: space-between;
  `,
  signInBox: css`
    background-color: #ffFFFF;
    display: flex;
    align-items: center;
    justify-items: center;
    margin-left: 24px;
    max-width: 364px;
    height: 314px;
    flex: 1;
    justify-content: center;
    flex-direction: column;
    svg {
      height: 137.34px;
      width: 137.34px;
    }
  `,
  signInText: css`
    max-width: 260px;
    text-align: center;
    margin: 16px;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  `
}
